import { makeStyles } from '@material-ui/core';
import { FONT_FAMILY } from 'muiTheme/config/typography';

export const typographyVariantObj = {
    dXl2Regular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '7.2rem',
        lineHeight: '9.0rem',
    },
    dXl2Medium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '7.2rem',
        lineHeight: '9.0rem',
    },
    dXl2Semibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '7.2rem',
        lineHeight: '9.0rem',
    },
    dXl2Bold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '7.2rem',
        lineHeight: '9.0rem',
    },
    dXlRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '6.0rem',
        lineHeight: '7.2rem',
    },
    dXlMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '6.0rem',
        lineHeight: '7.2rem',
    },
    dDxlSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '6.0rem',
        lineHeight: '7.2rem',
    },
    xlBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '6.0rem',
        lineHeight: '7.2rem',
    },
    dLgRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '4.8rem',
        lineHeight: '6.0rem',
    },
    dLgMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '4.8rem',
        lineHeight: '6.0rem',
    },
    dLgSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '4.8rem',
        lineHeight: '6.0rem',
    },
    dLgBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '4.8rem',
        lineHeight: '6.0rem',
    },
    dMdRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '3.6rem',
        lineHeight: '4.4rem',
    },
    dMdMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '3.6rem',
        lineHeight: '4.4rem',
    },
    dMdSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '3.6rem',
        lineHeight: '4.4rem',
    },
    dMdBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '3.6rem',
        lineHeight: '4.4rem',
    },
    dSmRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '3.0rem',
        lineHeight: '3.8rem',
    },
    dSmMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '3.0rem',
        lineHeight: '3.8rem',
    },
    dSmSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '3.0rem',
        lineHeight: '3.8rem',
    },
    dSmBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '3.0rem',
        lineHeight: '3.8rem',
    },
    dXsRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '2.4rem',
        lineHeight: '3.2rem',
    },
    dXsMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '2.4rem',
        lineHeight: '3.2rem',
    },
    dXsSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '2.4rem',
        lineHeight: '3.2rem',
    },
    dXsBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '2.4rem',
        lineHeight: '3.2rem',
    },
    tXlRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '2.0rem',
        lineHeight: '3.0rem',
    },
    tXlMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '2.0rem',
        lineHeight: '3.0rem',
    },
    tXlSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '2.0rem',
        lineHeight: '3.0rem',
    },
    tXlBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '2.0rem',
        lineHeight: '3.0rem',
    },
    tLgRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '1.8rem',
        lineHeight: '2.8rem',
    },
    tLgMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '1.8rem',
        lineHeight: '2.8rem',
    },
    tLgSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '1.8rem',
        lineHeight: '2.8rem',
    },
    tLgBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '1.8rem',
        lineHeight: '2.8rem',
    },
    tMdRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '1.6rem',
        lineHeight: '2.4rem',
    },
    tMdMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '1.6rem',
        lineHeight: '2.4rem',
    },
    tMdSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '1.6rem',
        lineHeight: '2.4rem',
    },
    tMdBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '1.6rem',
        lineHeight: '2.4rem',
    },
    tSmallRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '1.4rem',
        lineHeight: '2.0rem',
    },
    tSmallMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '1.4rem',
        lineHeight: '2.0rem',
    },
    tSmallSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '1.4rem',
        lineHeight: '2.0rem',
    },
    tSmallBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '1.4rem',
        lineHeight: '2.0rem',
    },
    tXsRegular: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '1.2rem',
        lineHeight: '1.8rem',
    },
    tXsMedium: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '1.2rem',
        lineHeight: '1.8rem',
    },
    tXsSemibold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '1.2rem',
        lineHeight: '1.8rem',
    },
    tXsBold: {
        fontFamily: FONT_FAMILY,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '1.2rem',
        lineHeight: '1.8rem',
    },
};

export default makeStyles((theme) => typographyVariantObj);
